import { Injectable } from '@angular/core';
import { Vademecum } from './vademecum';

@Injectable({
  providedIn: 'root'
})
export class VademecumService {

  public vademecum!: Vademecum;

  constructor() { }
}
